(function () {
  function getCartItemCount() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return cart.item_count || 0; })
      .catch(function () { return 0; });
  }

  function updateProgressBarEnhanced(container) {
    const checkpointsJson = container.querySelector('#progress-checkpoints');
    if (!checkpointsJson) return;

    const checkpointsText = checkpointsJson.textContent;
    if (!checkpointsText) return;

    let checkpoints;
    try {
      checkpoints = JSON.parse(checkpointsText);
    } catch (error) {
      console.error('Error parsing checkpoints JSON:', error);
      return;
    }

    if (!Array.isArray(checkpoints) || checkpoints.length === 0) return;

    getCartItemCount().then(function (count) {
      // count = quantidade total de unidades no carrinho (cart.item_count)
      const currentCount = count;

      // value = número de itens necessário para cada checkpoint
      checkpoints.forEach(cp => { cp.threshold = cp.value; });
      checkpoints.sort((a, b) => a.threshold - b.threshold);
      const maxThreshold = checkpoints[checkpoints.length - 1].threshold;

      let progressPercentage;
      if (maxThreshold === 0) {
        progressPercentage = 100;
      } else {
        progressPercentage = Math.min((currentCount / maxThreshold) * 100, 100);
      }
      progressPercentage = Math.min(progressPercentage, 100);

      /** @type {{value: number, threshold: number, id: number} | null} */
      let nextCp = null;
      for (const cp of checkpoints) {
        if (cp.threshold > currentCount) {
          if (nextCp === null || cp.threshold < nextCp.threshold) {
            nextCp = { value: cp.value, threshold: cp.threshold, id: cp.id };
          }
        }
      }

      const progressFill = container.querySelector('.progress-fill-enhanced');
      if (progressFill instanceof HTMLElement) {
        const finalWidth = Math.min(progressPercentage, 100);
        progressFill.style.width = `${finalWidth}%`;
      }

      const messageElem = container.querySelector('.progress-message-enhanced');
      if (messageElem instanceof HTMLElement) {
        if (nextCp && nextCp !== null) {
          // Quantos itens faltam para o próximo checkpoint
          const remaining = nextCp.threshold - currentCount;
          const messageElement = container.querySelector(`#checkpoint-messages [data-id="${nextCp.id}"]`);
          const messageContent = messageElement ? messageElement.textContent || messageElement.innerHTML : '';
          const progressText = messageElem.querySelector('.progress-text');
          if (progressText) {
            progressText.innerHTML = messageContent
              .replace('{count}', remaining)
              .replace('{amount}', remaining);
            progressText.classList.remove('progress-complete');
          }
        } else {
          const completionElement = container.querySelector('#completion-message');
          const progressText = messageElem.querySelector('.progress-text');
          if (progressText) {
            progressText.innerHTML = completionElement ? completionElement.textContent || completionElement.innerHTML : '';
            progressText.classList.add('progress-complete');
          }
        }
      }

      container.querySelectorAll('.checkpoint-enhanced').forEach(el => {
        if (!(el instanceof HTMLElement)) return;
        const datasetValue = el.dataset.value;
        if (!datasetValue) return;
        // data-value = número de itens necessário (vem do Liquid)
        const cpThreshold = parseFloat(datasetValue);
        if (isNaN(cpThreshold)) return;
        if (cpThreshold <= currentCount) {
          el.classList.add('reached');
        } else {
          el.classList.remove('reached');
        }
      });
    }).catch(function () { /* noop */ });
  }

  function updateAll() {
    var roots = document.querySelectorAll('.cart-progress-enhanced');
    if (!roots.length) {
      setTimeout(function() {
        var delayedRoots = document.querySelectorAll('.cart-progress-enhanced');
        if (delayedRoots.length) updateAll();
      }, 300);
      return;
    }

    roots.forEach(function (root) {
      updateProgressBarEnhanced(root);
    });
  }

  window.CartProgressBar = window.CartProgressBar || { update: updateAll };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateAll);
  else setTimeout(updateAll, 100);

  document.addEventListener('cart:updated', updateAll);
  document.addEventListener('theme:cart-update', updateAll);
  document.addEventListener('cart:update', updateAll);
  document.addEventListener('dialog:opened', function() { setTimeout(updateAll, 200); });

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function(mutations) {
      var needs = mutations.some(function(m) {
        return Array.prototype.some.call(m.addedNodes, function(n) {
          return n.nodeType === 1 && (n.classList && n.classList.contains('cart-progress-enhanced') || (n.querySelector && n.querySelector('.cart-progress-enhanced')));
        });
      });
      if (needs) setTimeout(updateAll, 100);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
